import axios from 'axios';

// Same base + auth convention as services/appConfig.js (x-auth-token from
// storage) against the root /api.
const API_URL = `${process.env.REACT_APP_API_URL}/api`;

function authHeaders() {
  let token = null;
  try {
    token = localStorage.getItem('token') || sessionStorage.getItem('token');
  } catch (_) {
    // storage can be blocked — the request goes out unauthenticated and the
    // caller treats the 401 like any other error
  }
  return token ? { 'x-auth-token': token } : {};
}

/**
 * Has this ACCOUNT already answered the web push prompt (enabled or skipped)?
 *
 * The answer lives on the user's Setting doc (`showNotificationPrompt ===
 * false`), not in this browser: localStorage is per browser profile AND per
 * origin, so the old browser-only flag re-asked on every device, every
 * incognito window and every coach subdomain (app.getnubod.com and
 * <coach>.getnubod.com don't share storage).
 *
 * Only "no Setting doc yet" (the API answers 400) means "not answered". Any
 * other failure (network, expired token) counts as answered so a flaky load
 * never turns into a nag — the next load asks the server again.
 */
export async function isNotificationPromptDismissed() {
  try {
    const { data } = await axios.get(`${API_URL}/setting/me`, {
      headers: authHeaders(),
    });
    return data?.showNotificationPrompt === false;
  } catch (err) {
    return err?.response?.status !== 400;
  }
}

/** Record that the prompt was answered, so no device asks this account again. */
export async function dismissNotificationPrompt() {
  await axios.post(
    `${API_URL}/setting`,
    { showNotificationPrompt: false },
    { headers: authHeaders() }
  );
}
